import React, { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import { Pagination, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/pagination';
import axios from 'axios';

const IndustriesProjectSection = () => {
    const [project, setProject] = useState([]);
    const [categories, setCategories] = useState([]);
    const {slug} = useParams()
    const decodedSlug = decodeURIComponent(slug.replace(/-/g, ' ')).toLowerCase();
    

    useEffect(() => {
        const fetchProjectsAndCategories = async () => {
            try {
                const [projectsRes, categoriesRes] = await Promise.all([
                    axios.get(`https://api.rashtechinfo.com/getAllProjects`),
                    axios.get(`https://api.rashtechinfo.com/getAllProjectCategories`)
                ]);
                
                setProject(projectsRes.data.data || []);
                setCategories(categoriesRes.data.categories || []);
            } catch (error) {
                console.log(error);
            }
        };
        fetchProjectsAndCategories();
    }, []);

    const getCategoryName = (categoryId) => {
        const cat = categories.find(c => c._id === categoryId);
        return cat ? cat.categoryName : '';
    };
    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }


    const filteredProjects = project.filter((prj) => {
    const categoryName = getCategoryName(prj.projectCategory).toLowerCase();
    return categoryName === decodedSlug;
  });

    

    return (
        <div>
            {filteredProjects.length > 0 &&
        <section className="portfolio_section xb-hidden section_space pb-0">
            <div className="container">
                <div className="heading_block">
                    <div className="row align-items-end">
                        <div className="col-lg-7">
                            <div className="heading_focus_text">
                                <span className="badge bg-secondary text-white">Crafting</span>
                                Success With Project
                            </div>
                            <h2 className="heading_text">
                                Our Industry Related Works
                            </h2>
                            <p className="heading_description mb-0">
                                Our recent projects highlight our expertise in delivering tailored solutions that meet the unique needs and objectives of our clients,custom software.
                            </p>
                        </div>
                        <div className="col-lg-5 d-none d-lg-flex justify-content-end">
                            <Link onClick={ClickHandler} to={'/portfolio'} className="btn btn-primary">
                                <span className="btn_label" data-text="All Works">All Works</span>
                                <span className="btn_icon">
                                    <i className="fa-solid fa-arrow-up-right"></i>
                                </span>
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
            <div className="portfolio_carousel">
                <Swiper
                    // install Swiper modules
                    modules={[Pagination, A11y]}
                    slidesPerView={1}
                    loop={true}
                    spaceBetween= {30}
                    allowTouchMove= {true}
                    centeredSlides= {true}
                    pagination={{ clickable: true }}
                    speed={400}
                    parallax={true}
                    breakpoints={{
                        1025: {
                            slidesPerView: 2,
                        },
                    }}
                >

                    {filteredProjects.slice(0, 5).map((project, prj) => (
                        <SwiperSlide key={prj}>
                            <div className="portfolio_block" >
                                <div className="portfolio_image">
                                    <Link onClick={ClickHandler} className="portfolio_image_wrap bg-light" to={`/portfolio/${project.Project_title.replace(/\s+/g, "-")}`}>
                                        <img src={`https://api.rashtechinfo.com/uploads/${project.projectImage}`} alt="Mobile App Design"  />
                                    </Link>
                                </div>
                                <div className="portfolio_content">
                                    <h3 className="portfolio_title">
                                        <Link onClick={ClickHandler} to={`/portfolio/${project.Project_title.replace(/\s+/g, "-")}`}>
                                            {project.Project_title}
                                        </Link>
                                    </h3>
                                    <ul className="category_list unordered_list">
                                        <li>
                                            <Link onClick={ClickHandler} to={`/portfolio/${project.Project_title.replace(/\s+/g, "-")}`}>
                                                {getCategoryName(project.projectCategory)}
                                            </Link>
                                        </li>
                                    </ul>
                                    <Link onClick={ClickHandler} className="btn btn-outline-light" to={`/portfolio/${project.Project_title.replace(/\s+/g, "-")}`}>
                                        <span className="btn_label" data-text="Explore">Explore</span>
                                        <span className="btn_icon">
                                            <i className="fa-solid fa-arrow-up-right"></i>
                                        </span>
                                    </Link>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
            <div className="container text-center d-block d-lg-none">
                <div className="btns_group pb-0">
                    <Link onClick={ClickHandler} className="btn btn-primary" to="/pricing">
                        <span className="btn_label" data-text="All Works">All Works</span>
                        <span className="btn_icon">
                            <i className="fa-solid fa-arrow-up-right"></i>
                        </span>
                    </Link>
                </div>
            </div>
        </section>
        }
        </div>
    );
}

export default IndustriesProjectSection;